export function currency (num) {
    if(num === 0 || !num ) return '0'
    const n = parseInt(num, 10)
    return `${n.toFixed(0).replace(/./g, (c, i, a) => (i && c !== '.' && ((a.length - i) % 3 === 0) ? `, ${c}`.replace(/\s/g, '') : c))}`
  }